import { render } from "./StatsWidgetDataConfigOption.vue?vue&type=template&id=4ea51343&scoped=true"
import script from "./StatsWidgetDataConfigOption.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetDataConfigOption.vue?vue&type=script&lang=ts"

import "./StatsWidgetDataConfigOption.vue?vue&type=style&index=0&id=4ea51343&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ea51343"

export default script